import blurredBackground from '@src/static/images/landing/blurred-background.jpg';
import commercial from '@src/static/images/landing/commercial.jpg';
import { markdownify } from '@src/utils';
import find from 'lodash/find';
import get from 'lodash/get';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';

import choose from '../../static/images/icon/landing/choose.svg';
import hotCup from '../../static/images/icon/landing/hot-cup.svg';
import location from '../../static/images/icon/landing/location.svg';
import cover from '../../static/images/landing/map.jpg';
import pattern from '../../static/images/landing/pattern.svg';
import hybridElectric from '../../static/images/landing/phone-animation.svg';
import affirmDark from '../../static/images/logos/affirm-dark.png';
import videoThumbnail from '../../static/images/video-thumbnail.png';

const VideoModalCommercial = dynamic(import('@src/components/modals/VideoModalCommercial'));
const Reviews = dynamic(import('../../components/category/Reviews'));
const ContactModal = dynamic(import('../../components/modals/ContactModal'));
const VideoModal = dynamic(import('../../components/modals/VideoModal'));

function HybridElectricLandingPage({ phoneNumber, geolocation, myHref, asVar, googleNumber, CMSData }) {
	const [contactModalOpen, setcontactModalOpen] = useState(false);
	const [videoModalOpen, setvideoModalOpen] = useState(false);
	const [videoModalCommercial, setvideoModalCommercialOpen] = useState(false);

	const sections = get(CMSData, 'sections');
	const coverText =
		find(sections, { section_id: 'cover_text' }) && find(sections, { section_id: 'cover_text' }).content;
	const descriptionText =
		find(sections, { section_id: 'description' }) && find(sections, { section_id: 'description' }).content;
	const features = find(sections, { section_id: 'features' }) && find(sections, { section_id: 'features' }).features;
	const tagline = find(sections, { section_id: 'features' }) && find(sections, { section_id: 'features' }).subtitle;
	const howTheProcessWorks = find(sections, { section_id: 'how_it_works' });

	useEffect(() => {
		// FIXME: document not accessible instantly on load (V.T. 11.2.2022)
		if (typeof window !== 'undefined') {
			if (document.querySelectorAll('h2 strong').length > 0) {
				const addressDescription = document.querySelectorAll('h2 strong');
				addressDescription[0].innerHTML =
					geolocation && geolocation.formatted_address ? geolocation.formatted_address : 'Your Area';
			}
		}
	}, []);

	return (
		<div className="landing hybrid-electric">
			<ContactModal
				toPhoneNumber={phoneNumber}
				open={contactModalOpen}
				onCloseModal={() => setcontactModalOpen(false)}
			/>
			<VideoModal open={videoModalOpen} onCloseModal={() => setvideoModalOpen(false)} />
			<VideoModalCommercial open={videoModalCommercial} onCloseModal={() => setvideoModalCommercialOpen(false)} />
			<div
				className="cover-container"
				style={{
					background: `#FFFFFF url(${cover.src}) bottom left`,
				}}>
				<div>
					<div className={`cover`}>
						<div className="container">
							<div className="item-element">
								<div className="text-container">
									<h1>
										{coverText || 'Hybrid and Electric Battery Replacement in'}{' '}
										<span>{`${
											geolocation && geolocation.formatted_address
												? geolocation.formatted_address
												: 'Your City'
										}`}</span>
									</h1>
									<div className="search-form">
										<div className="action-buttons">
											<div className="inner">
												<div>
													<Link href={myHref} as={asVar}>
														<a className="btn book">
															<i className="fas fa-car-battery"></i> Schedule Online{' '}
														</a>
													</Link>
												</div>

												<div>
													<a className="btn text-us" href={`tel:${googleNumber}`}>
														<i className="fas fa-phone"></i> <span>Get Help Now</span>
													</a>
												</div>
											</div>
										</div>

										<div className="gradient-border mt-3"></div>
										<div>
											<Reviews type="minimal" />
										</div>
									</div>
								</div>

								<div className="image-container">
									<img src={hybridElectric.src} />
									<div className="disclaimers">
										<div className="disclaimer">
											<div className="inner">
												<i className="fas fa-check-circle"></i>
												<h6>
													In Route <br></br> Communication
												</h6>
											</div>
										</div>

										<div className="disclaimer">
											<div className="inner">
												<i className="fas fa-check-circle"></i>
												<h6>
													Uber Like <br></br> Experience
												</h6>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="services"></div>
			</div>

			<div
				className="bottom-container"
				style={{
					background: `#FFFFFF url(${pattern.src}) center center`,
				}}>
				<div className="container">
					<div className="bottom">
						<div className="items-container">
							{features &&
								features.map((item, i) => {
									const icons = ['fas fa-shipping-fast', 'fas fa-calendar-check', 'fas fa-wrench'];
									return (
										<div className="item" key={item.title}>
											<div className="img">
												<i className={icons[i]} aria-hidden="true"></i>
											</div>
											<div className="text">
												<h5>{item.title}</h5>
												<p>{item.content}</p>
											</div>
										</div>
									);
								})}

							{!features && (
								<>
									<div className="item">
										<div className="img">
											<i className="fas fa-shipping-fast" aria-hidden="true"></i>
										</div>
										<div className="text">
											<h5>FAST DELIVERY</h5>
											<p>Most orders are 90 minutes or Less</p>
										</div>
									</div>
									<div className="item">
										<div className="img">
											<i className="fas fa-calendar-check" aria-hidden="true"></i>
										</div>
										<div className="text">
											<h5 className="">Make an Appointment</h5>
											<p className="">
												Not an Emergency, schedule an appointment at your around your busy
												schedule.
											</p>
										</div>
									</div>
									<div className="item">
										<div className="img">
											<i className="fas fa-wrench" aria-hidden="true"></i>
										</div>
										<div className="text">
											<h5 className="">PROFESSIONAL INSTALLATION!</h5>
											<p className="">
												We Test Electrical, Install New Battery, Test Again and Recycle old
												Battery <small>(Computer Resets too)</small>
											</p>
										</div>
									</div>
								</>
							)}
						</div>
						{tagline && markdownify(tagline)}
						{!tagline && (
							<p>
								We are the <strong>largest Battery Marketplace</strong> in North America. Over{' '}
								<strong>10,000</strong> products, <strong>250,000</strong> locations, and{' '}
								<strong>1,000,000</strong> needs served.
							</p>
						)}
					</div>
				</div>
				<div id="how-it-works"></div>
			</div>

			<div className={`banner-with-sample-report align-middle`}>
				<div className="inner">
					<div className="container">
						<div className="row">
							<div className="col-md-8 align-middle">
								<div className="text">
									<h3>{howTheProcessWorks ? howTheProcessWorks.title : 'How the Process Works'}</h3>
									<p>
										{howTheProcessWorks
											? howTheProcessWorks.subtitle
											: 'This is the easiest to use Battery platform in the world today, combining the best about DoorDash, Uber, and making the installation of batteries transparent and cheaper for you. From Prices to Delivery, we keep you informed and no hidden fees. If you have any questions we are always available. Please watch the 90 second video for more info.'}
									</p>
								</div>
							</div>

							<div className="col">
								<div className="image" onClick={() => setvideoModalOpen(true)}>
									<div>
										<Image
											width="400px"
											height="229px"
											src={videoThumbnail}
											alt="Car Battery Installation Video"
											className="lazyload"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="steps">
				<div className="container">
					<div className="inner">
						<div className="row">
							{howTheProcessWorks ? (
								<>
									{howTheProcessWorks.features.map((item, index) => {
										const images = [location.src, choose.src, hotCup.src];
										return (
											<div className="col" key={index}>
												<Link href={myHref} as={asVar} passHref>
													<div className="item">
														{index === 0 && <span className="start-here">Start Here</span>}
														<img src={images[index]} alt="" className="lazyload" />

														<h4>Step {index + 1}</h4>
														<h6>{item.title}</h6>
														<p>{item.content}</p>
													</div>
												</Link>
											</div>
										);
									})}
								</>
							) : (
								<>
									<div className="col">
										<Link href={myHref} as={asVar} passHref>
											<div className="item">
												<span className="start-here">Start Here</span>
												<img src={location.src} alt="" className="lazyload" />

												<h4>Step 1</h4>
												<h6>Provide your Information</h6>
												<p>
													We will provide an immediate price quote based on your vehicle model
													and location.
												</p>
											</div>
										</Link>
									</div>

									<div className="col">
										<Link href={myHref} as={asVar} passHref>
											<div className="item">
												<img src={choose.src} alt="" className="lazyload" />

												<h4>Step 2</h4>
												<h6>Select your Service Option</h6>
												<p>
													We offer <span>Pickup, Delivery and Installation</span> options.
												</p>
											</div>
										</Link>
									</div>

									<div className="col">
										<Link href={myHref} as={asVar} passHref>
											<div className="item no-affirm-disclaimer-border">
												<img src={hotCup.src} alt="" className="lazyload" />

												<h4>Step 3</h4>
												<h6>Place your order and we do the rest.</h6>
												<p>
													If you choose Delivery we’ll come to you. If you choose a Store our
													Technicians will be waiting for you.
												</p>
											</div>
										</Link>
									</div>
								</>
							)}
						</div>
					</div>
				</div>
			</div>

			{/* <div className="container">
        <FlowPreview />
      </div> */}

			<div className="dynamic-content">
				<div className="container">
					<div className="row">
						<div className="col-md-8">
							<article>
								{descriptionText ? (
									markdownify(descriptionText)
								) : (
									<>
										<p>
											Your car battery seems to run a little rough, with multiple starts needed or
											stalling throughout your drive. Or, you find your car won’t start at all —
											and you’re miles away from home.
										</p>

										<p>
											Making an appointment for car battery replacement services seems like the
											most logical solution. But, when you’re stranded, you need service now — no
											waiting, no calling for a friend to pick you up, and no coordinating with a
											towing company to get your vehicle to the closest auto shop.
										</p>

										<p>
											For the{' '}
											{`${
												geolocation && geolocation.formatted_address
													? geolocation.formatted_address
													: 'your'
											}`}{' '}
											area, 1-800-Battery provides fast mobile car battery replacement and install
											services. We build off our status as the largest batter marketplace in North
											America to offer just-in-time and precise car battery installation. When you
											need us, we’re there, accompanied by our wealth of knowledge.
										</p>

										<h2>
											Car Battery Delivery and Installation in{' '}
											<strong>{`${
												geolocation && geolocation.formatted_address
													? geolocation.formatted_address
													: 'Your Area'
											}`}</strong>
										</h2>
										<p>
											Yes, we offer car batteries for sale among our more than 10,000 products.
											But, 1-800-Battery is more than just a retailer; we provide our customers
											with white-glove car and truck battery installation, too. What can we offer
											you, whether you need car battery replacement now or in the near future?
										</p>

										<ul>
											<li>
												<strong>We&apos;re cheaper than any dealership</strong>, and quicker,
												too. Instead of expensive towing and lengthy appointment times, we come
												to you with the correct battery for your vehicle. And, rather than
												tacking on extra fees, we roll the cost of installation into our single,
												transparent price.
											</li>
											<li>
												<strong>We’re home of the JumpStart Guarantee:</strong> Also unlike
												dealerships, we won’t pressure you to replace your car battery.Instead,
												unless testing shows it’s needed, we keep your existing battery in your
												car.
											</li>

											<li>
												<strong>We also offer a Correct Battery Guarantee:</strong> We carry{' '}
												<a href="https://1800battery.com/category/vehicle-batteries-car-or-truck/">
													car and truck batteries
												</a>{' '}
												by make and model. We’ll be prepared, no matter the notice, with the
												corresponding solution.
											</li>

											<li>
												<strong>Get service when you need it:</strong> Book an appointment
												online for immediate delivery and service, or schedule an appointment
												for a later date. For same-day work, we’ll drive out to your location —
												home, work parking lot or the side of the road in the Miami area — with
												the right car or truck battery from our expansive product selection.
											</li>

											<li>
												<strong>We prioritize service</strong> Along with rapid response, our
												professionals provide full car battery replacement service.We test the
												existing battery, can install a new unit, and then test it again to
												ensure everything’s working.We then recycle the old battery.
											</li>
										</ul>

										<p>
											Don’t wait around or go for weeks without a car.If you&apos;re in{' '}
											{`${
												geolocation && geolocation.formatted_address
													? geolocation.formatted_address
													: 'need'
											}`}{' '}
											and your car battery clearly needs replacement, get it done quickly and
											accurately with 1-800-Battery. Contact us today to set up an appointment.
										</p>
									</>
								)}
							</article>
						</div>

						<div className="col-md-4">
							<div className="landing-checklist in-sidebar mt-0">
								<div className="item odd">
									<i className="fas fa-check"></i>
									<span>Book Online for Immediate Delivery or Make Appointment</span>
								</div>

								<div className="item">
									<i className="fas fa-check"></i>
									<span>Installation Included in Price - No Hidden Charges!</span>
								</div>

								<div className="item odd">
									<i className="fas fa-check"></i>
									<span>Our JumpStart Guarantee!</span>
								</div>

								<div className="item ">
									<i className="fas fa-check"></i>
									<span>Professional Technicans with Real Time Tracking!</span>
								</div>

								<div className="item ">
									<i className="fas fa-check"></i>
									<span>
										Buy now, pay over time with{' '}
										<img
											src={affirmDark.src}
											alt="Car Battery Installation Video"
											className="lazyload"
										/>
									</span>
								</div>
							</div>

							<div className="search-form">
								<div className="action-buttons sidebar">
									<div className="inner">
										<Link href={myHref} as={asVar} passHref>
											<a className="btn book">
												<i className="fas fa-shopping-cart"></i> Book Online{' '}
											</a>
										</Link>

										<a className="btn text-us" href="tel:tel:+18002288379">
											<i className="fas fa-phone" aria-hidden="true"></i>{' '}
											<span>Get Help Now</span>
										</a>
									</div>
								</div>

								<div className="mt-md-3 reviews-sidebar">
									<Reviews type="minimal" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="container">
				<div
					className="commercial"
					style={{
						background: `url(${blurredBackground.src}) center center`,
					}}>
					<div className="inner" onClick={() => setvideoModalCommercialOpen(true)}>
						<div className="tv">
							<div className="icon-container">
								<span>
									<i className="fas fa-play-circle"></i>
								</span>
							</div>
							<img src={commercial.src} alt="commercial" />
						</div>
						<p>Watch our commercial</p>
					</div>
				</div>
			</div>

			<div className="container">
				<Reviews type="static" />
			</div>

			<div className="container text-center">
				<div className="search-form">
					<div className="action-buttons">
						<div className="inner justify-content-center">
							<div>
								<Link href={myHref} as={asVar}>
									<a className="btn book">
										<i className="fas fa-car-battery"></i> Schedule Online{' '}
									</a>
								</Link>
							</div>

							<div>
								<a className="btn text-us" href={`tel:${googleNumber}`}>
									<i className="fas fa-phone"></i> <span>Get Help Now</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* {(cities >= 1) &&
            <div className="container">
              <div className="landing-nearby-cities">
                <h3>Nearby Cities</h3>
                <ul>
                  {cities.map(item => (
                    <li><a href={`/${slug[1]}/${slug[2]}/${item.urlSlug}`}>{item.cityName}</a></li>
                  ))}
                </ul>
              </div>
            </div>
          } */}
		</div>
	);
}

export default HybridElectricLandingPage;
